// Product Custom Slider Component
// Handles slider navigation with arrow buttons only (no swipe, no scroll)

if (!customElements.get('product-custom-slider')) {
  customElements.define('product-custom-slider', class ProductCustomSlider extends HTMLElement {
    constructor() {
      super();
      this.wrapper = this.querySelector('.slider__wrapper');
      this.items = this.querySelectorAll('.slider__item');
      this.prevBtn = this.querySelector('.slider__prev');
      this.nextBtn = this.querySelector('.slider__next');
      this.currentIndex = 0;
      this.itemsPerView = 2; // Show 2 items at a time
      this.maxIndex = Math.max(0, this.items.length - this.itemsPerView);
    }

    connectedCallback() {
      if (!this.wrapper || !this.prevBtn || !this.nextBtn || this.items.length === 0) {
        console.warn('Product Custom Slider: Missing required elements');
        return;
      }

      // Match slider 1 height to slider 2's contain image
      this.matchSliderHeights();

      // Disable scroll on wrapper
      this.wrapper.style.overflowX = 'hidden';
      
      // Prevent touch/swipe gestures
      this.wrapper.addEventListener('touchstart', (e) => e.preventDefault(), { passive: false });
      this.wrapper.addEventListener('touchmove', (e) => e.preventDefault(), { passive: false });
      
      // Prevent mouse wheel scroll
      this.wrapper.addEventListener('wheel', (e) => e.preventDefault(), { passive: false });
      
      // Prevent drag scroll
      this.wrapper.addEventListener('mousedown', (e) => e.preventDefault());

      // Arrow button click handlers
      this.prevBtn.addEventListener('click', () => this.slidePrev());
      this.nextBtn.addEventListener('click', () => this.slideNext());

      // Initialize: update button states
      this.updateButtons();
      
      console.log('Product Custom Slider initialized:', {
        totalItems: this.items.length,
        itemsPerView: this.itemsPerView,
        maxIndex: this.maxIndex
      });
    }

    slidePrev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateSlider();
      }
    }

    slideNext() {
      if (this.currentIndex < this.maxIndex) {
        this.currentIndex++;
        this.updateSlider();
      }
    }

    updateSlider() {
      // Calculate scroll position
      // Each item is 50% width with 10px gap
      const itemWidth = this.wrapper.offsetWidth / this.itemsPerView;
      const gap = 10;
      const scrollPosition = this.currentIndex * (itemWidth + gap);

      // Smooth scroll to position
      this.wrapper.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });

      // Update button states
      this.updateButtons();
    }

    matchSliderHeights() {
      const containItem = this.querySelector('.slider__item--contain');
      if (!containItem) return;

      const containImg = containItem.querySelector('img');
      if (!containImg) return;

      const bigImage = document.querySelector('.product-custom__big-image img');
      const bottomImage = document.querySelector('.product-custom__bottom-image');
      const gap = 10;

      const resetStyles = () => {
        this.items.forEach(item => {
          item.style.height = '';
          item.style.aspectRatio = '';
        });
        this.wrapper.style.height = '';
        this.closest('.product-custom__slider').style.height = '';
        if (bigImage) bigImage.style.height = '';
      };

      const doMatch = () => {
        // Only apply on desktop (750px+)
        if (window.innerWidth < 750) {
          resetStyles();
          return;
        }

        const containerWidth = containItem.offsetWidth;
        const naturalW = containImg.naturalWidth;
        const naturalH = containImg.naturalHeight;
        if (!naturalW || !naturalH) return;

        // Calculate rendered height of contain image (slider)
        const imgAspect = naturalW / naturalH;
        const sliderHeight = containerWidth / imgAspect;

        // Apply height to all slider items
        this.items.forEach(item => {
          item.style.height = sliderHeight + 'px';
          item.style.aspectRatio = 'unset';
        });

        // Update wrapper/slider height
        this.wrapper.style.height = sliderHeight + 'px';
        this.closest('.product-custom__slider').style.height = sliderHeight + 'px';

        // Big image = slider height + bottom height + gap
        if (bigImage && bottomImage) {
          const bottomHeight = bottomImage.offsetHeight;
          const bigHeight = sliderHeight + bottomHeight + gap;
          bigImage.style.height = bigHeight + 'px';
        }
      };

      if (containImg.complete) {
        doMatch();
      } else {
        containImg.addEventListener('load', doMatch);
      }

      window.addEventListener('resize', () => {
        resetStyles();
        doMatch();
      });
    }

    updateButtons() {
      // Disable prev button at start
      if (this.currentIndex === 0) {
        this.prevBtn.disabled = true;
        this.prevBtn.style.opacity = '0.5';
        this.prevBtn.style.cursor = 'not-allowed';
      } else {
        this.prevBtn.disabled = false;
        this.prevBtn.style.opacity = '1';
        this.prevBtn.style.cursor = 'pointer';
      }

      // Disable next button at end
      if (this.currentIndex >= this.maxIndex) {
        this.nextBtn.disabled = true;
        this.nextBtn.style.opacity = '0.5';
        this.nextBtn.style.cursor = 'not-allowed';
      } else {
        this.nextBtn.disabled = false;
        this.nextBtn.style.opacity = '1';
        this.nextBtn.style.cursor = 'pointer';
      }
    }
  });
}
